import { render, staticRenderFns } from "./VehiclesBrandIndexModal.vue?vue&type=template&id=28163c38&scoped=true"
import script from "./VehiclesBrandIndexModal.vue?vue&type=script&lang=js"
export * from "./VehiclesBrandIndexModal.vue?vue&type=script&lang=js"
import style0 from "./VehiclesBrandIndexModal.vue?vue&type=style&index=0&id=28163c38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28163c38",
  null
  
)

export default component.exports